import { Ban, Mail } from 'lucide-react';

import { EmptyBlock } from '@/components/ui/empty-block';
import { Button } from '@/components/ui/button';
import env from 'env';

const BillingNoAccessState = () => {
  const onContactSupport = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`, '_blank');

  return (
    <EmptyBlock
      title="You don’t have access to this information."
      description="Only account owners can access the billing page. If you think this is a mistake, reach out to us below."
      icon={Ban}
      action={
        <Button onClick={onContactSupport}>
          <Mail />
          Contact us
        </Button>
      }
    />
  );
};

export default BillingNoAccessState;
